export default __webpack_public_path__ + "static/media/schedule_tablet.f07e2f8e.jpg";